import React, { Component, Fragment } from 'react';
import JSZip from 'jszip';
import JSZipUtils from '../../utils/JSZipUtils';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { API_BASE_URL } from  '../../config';

class DicomStudyDownloader extends Component {
  state = {
    downloadInProgress: false,
    totalFiles: 0,
    downloadedFiles: 0,
    downloadProgress: 0,
    zippingInProgress: false,
    zippingProgress: 0,
  }
  constructor(props) {
    super(props);
    this.updateZippingCallback = this.updateZippingCallback.bind(this);
  }

  updateZippingCallback(meta){
    let currentPercent = meta.percent.toFixed(0)
    let { zippingProgress } = this.state
    if( currentPercent != zippingProgress  ){
      this.setState({
        zippingProgress : currentPercent
      });
    }

  }

  async downloadFiles() {
    const fetchFiles = await axios.get(`${API_BASE_URL}/file/patient-scans/${this.props.scanId}`)
    const fileList = fetchFiles.data.data;
    const zip = new JSZip();
    let count = 0;
    const zipFilename = `${this.props.scanId}.zip`;
    this.setState({
      downloadInProgress: true,
      totalFiles: fileList.length,
      downloadedFiles: count
    });
    fileList.forEach(async function (file, index){
      const filename = file.name;
      let url = `${API_BASE_URL}/patient-scan/download-dicom-file/${this.props.scanId}/${filename}`;
      try {
        /*TODO: Attach auth header
        if (token) axios.defaults.headers.common['x-access-token'] = token; */
         
        const token = localStorage.getItem('jwtToken');
        
        const file = await JSZipUtils.getBinaryContent(url);
        zip.file(filename, file, { binary: true});
        count++;
        const progress = count / fileList.length * 100;
        const progressInPercent = progress.toFixed(0)
        this.setState({
          downloadedFiles: count,
          downloadProgress: progressInPercent
        });
        if(count === fileList.length) {
          this.setState({
            zippingInProgress: true,
            downloadInProgress: false,
          });
          zip.generateAsync({type:'blob'},(metadata) => this.updateZippingCallback(metadata)
        ).then(function(content) {
            saveAs(content, zipFilename);
            this.setState({
              zippingInProgress: false,
              zippingProgress: 0,
              downloadInProgress: false,
              totalFiles: 0,
            });
            this.props.setDownloadStudy(false);
          }.bind(this));
        }
      } catch (err) {
        console.log(err);
      }
    }, this);
  }

  componentDidMount() {
    this.downloadFiles();
  }

  render() {
    const { zippingInProgress, zippingProgress, downloadInProgress, downloadProgress } = this.state;
    if (downloadInProgress || zippingInProgress) return (
      <div className="absolute p-4 rounded-md shadow-md bottom-0 right-0 bg-gray-200 mb-12 mr-12" style={{width: '400px'}}>
        <div className="w-full">
            {downloadInProgress && 
            <>
              <p className="text-xs pb-1 text-gray-500 font-bold">Downloading files</p>
              <div className="flex justify-between items-center pb-1">
                <p className="text-sm text-indigo-700 font-bold">{downloadProgress}% complete</p>
              </div>
            </> 
            }
            {
              zippingInProgress && 
              <>
                <p className="text-xs pb-1 text-gray-500 font-bold">Zipping files</p>
                <div className="flex justify-between items-center pb-1">
                  <p className="text-sm text-indigo-700 font-bold">{zippingProgress}% complete</p>
                </div>
              </>
            }
          </div>
      </div>
    ) 
    return null;
  }
}
export default DicomStudyDownloader;